import { render } from "./ModuleSwitch.vue?vue&type=template&id=244e6c46"
import script from "./ModuleSwitch.vue?vue&type=script&lang=js"
export * from "./ModuleSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app.polyclip.com/releases/20250425172109/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__